// Sprint 2 API helpers
import { api } from "./api";

export const portalApi = {
  createToken: (customerId) => api.post("/portal/token", { customer_id: customerId }).then((r) => r.data),
  me: () => api.get("/portal/me").then((r) => r.data),
  tours: () => api.get("/portal/tours").then((r) => r.data),
  latestQuote: (tourId) => api.get(`/portal/tours/${tourId}/quote`).then((r) => r.data),
  documents: (tourId) => api.get(`/portal/tours/${tourId}/documents`).then((r) => r.data),
};

export const routingApi = {
  sample: () => api.get("/routing/sample").then((r) => r.data),
  analyze: (tourId, body) => api.post(`/tours/${tourId}/routing/analyze`, body).then((r) => r.data),
  drafts: (tourId) => api.get(`/tours/${tourId}/routing/drafts`).then((r) => r.data),
  promote: (draftId) => api.post(`/routing-drafts/${draftId}/promote`).then((r) => r.data),
  patch: (draftId, body) => api.patch(`/routing-drafts/${draftId}`, body).then((r) => r.data),
  resolveMileage: (draftId, body = null) => api.post(`/routing-drafts/${draftId}/resolve-mileage`, body).then((r) => r.data),
};

export const serviceApi = {
  list: (params = {}) => api.get("/service/work-orders", { params }).then((r) => r.data),
  create: (body) => api.post("/service/work-orders", body).then((r) => r.data),
  patch: (id, body) => api.patch(`/service/work-orders/${id}`, body).then((r) => r.data),
};

export const billingApi = {
  forTour: (tourId) => api.get(`/tours/${tourId}/billing`).then((r) => r.data),
};

export const reportsApi = {
  fleetUtil: (start, end) => api.get("/reports/fleet-utilization", { params: { start, end } }).then((r) => r.data),
  fleetUtilCsvUrl: (start, end) => `${process.env.REACT_APP_BACKEND_URL}/api/reports/fleet-utilization?start=${start}&end=${end}&format=csv`,
  activeTours: () => api.get("/reports/active-tours").then((r) => r.data),
  activeToursCsvUrl: () => `${process.env.REACT_APP_BACKEND_URL}/api/reports/active-tours?format=csv`,
  upcoming: (days = 30) => api.get("/reports/upcoming-departures", { params: { days } }).then((r) => r.data),
  upcomingCsvUrl: (days = 30) => `${process.env.REACT_APP_BACKEND_URL}/api/reports/upcoming-departures?days=${days}&format=csv`,
  coachAvail: (days = 14) => api.get("/reports/coach-availability", { params: { days } }).then((r) => r.data),
  quotePipeline: () => api.get("/reports/quote-pipeline").then((r) => r.data),
  quotePipelineCsvUrl: () => `${process.env.REACT_APP_BACKEND_URL}/api/reports/quote-pipeline?format=csv`,
};

export const FutureCapability = {
  // RC4 · Master Tour integration removed from the UI. Description
  // string kept as an inline comment for archaeological reference;
  // no code path references it.
  // masterTour: "Master Tour integration will allow approved tour routing and schedule data to be imported into ALL ACCESS COACH LEASING through the Master Tour REST API once production credentials/API access are supplied.",
  quickbooks: "Production connection will securely synchronize approved customers, invoices, payments and balances between ALL ACCESS COACH LEASING and QuickBooks Online. API credentials and OAuth authorization are required before activation.",
  eSignature: "E-signature capture will use a DocuSign or Adobe Sign integration once vendor selection and credentials are provided.",
  aiExtraction: "PDF/Excel routing extraction will use an OCR + LLM pipeline once vendor selection and credentials are provided.",
  mappingApi: "Interactive maps will use Google Maps or Mapbox once an API key is provided; timeline view is used until then.",
};
